import React, { useState, useEffect, useCallback } from 'react';
import { useApi } from '../../hooks/useApi';
import { DonorRecord, ApiDonorRecord } from '../../models/DonorRecord';
import { useAuthUserContext } from '../../providers';
import { UserType } from '../../types';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner';

const MyRecord = () => {
  const [ donorRecords, setDonorRecords ] = useState<DonorRecord[]>();
  const { get, post, loading } = useApi();
  const authUser = useAuthUserContext().user;
  const isDonee = authUser?.userType === UserType.Donee;
  const navigate = useNavigate();

  const fetchDonorRecords = useCallback(() => {
    get({
      endpoint: `/api/v1/donor_records`,
      params: { limit: "5" },
      onSuccess: (res) => {
        const apiDonorRecords: ApiDonorRecord[] = res.data;
        setDonorRecords(apiDonorRecords.map(r => new DonorRecord(r)))
      },
      onError: (err) => {
        console.error("[GET FAILED] /api/v1/donor_records");
      },
    });
  }, [ get ]);

  useEffect(() => {
    fetchDonorRecords();
  }, [ fetchDonorRecords ])

  const handleUpdateStatus = (id: number, status: 'APPROVED' | 'REJECTED', donorUserNo?: number) => {
    const actText = status === 'APPROVED' ? '承認' : '拒否';

    post({
      endpoint: '/api/v1/donor_records/update_status',
      body: { id, status },
      onSuccess: (updateRes) => {
        if (updateRes.status === 'error') {
          toast.error(updateRes.message);
          return;
        }

        fetchDonorRecords();

        if (status === 'APPROVED' && !updateRes.data.review_exist) {
          const shouldWriteReview = window.confirm('承認しました。続けてレビューを書きますか？');
          if (shouldWriteReview && donorUserNo) {
            navigate(`/mypage/reviews/${ donorUserNo }`);
          }
        } else {
          toast.success(`${ actText }しました`);
        }
      },
      onError: (err) => {
        toast.error(`${ actText }に失敗しました。時間をおいてお試しください。`);
      }
    });
  };

  const recordRows = donorRecords?.map(dr => {
    return (
      <tr key={ dr.id }>
        <td>{ isDonee ? dr.donor.name : dr.donee.name }様</td>
        <td>{ dr.donatedAt }</td>
        <td>{ dr.areaText }</td>
        <td>{ dr.methodText }</td>
        <td>
          { isDonee && dr.status === 'PENDING' ? (
            <ul>
              <li>
                <button className="pinkbtn" onClick={ () => handleUpdateStatus(dr.id, 'APPROVED', dr.donor.userNo) }>
                  承認
                </button>
              </li>
              <li>
                <button className="pinkbtn" onClick={ () => handleUpdateStatus(dr.id, 'REJECTED') }>
                  拒否
                </button>
              </li>
            </ul>
          ) : (
            dr.statusText
          )}
        </td>
      </tr>
    )
  })

  return (
    <section className="donor_record">
      <h2 className="main_title">
        <span>
          最新の提供実績
        </span>
      </h2>
      { !isDonee &&
        <Link to="/mypage/records/new" className="w_bluebtn" >新規登録</Link>
      }
      <div className={ `tableform ${ isDonee ? "pink" : "" }` }>
        <div className="scroll">
          <table>
            <tbody><tr>
              <th>{ isDonee ? "ドナー" : "ドニー" }</th>
              <th>日付</th>
              <th>エリア</th>
              <th>提供方法</th>
              <th>ステータス</th>
            </tr>
            { loading ? (
              <tr>
                <td colSpan={ 5 } style={ { textAlign: 'center', padding: '2rem' } }>
                  <Spinner color={ isDonee ? "pink" : "blue" } />
                </td>
              </tr>
            ) : (
              recordRows
            ) }
          </tbody></table>
        </div>
        <Link to="/mypage/records" className={ isDonee ? "w_pinkbtn" : "w_bluebtn" }>
          提供実績一覧
        </Link>
      </div>
    </section>
  );
}

export default MyRecord;
